import React, { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TableFooter,
  IconButton,
  TextField,
  Button
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { StyledTableCell, StyledTableRow } from "./Styles/TableAndCellStyles";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";

const CompletedSchedulesTable = ({ data, totalCount, loading, error, onUpdateBalance, onPageChange, onRowsPerPageChange }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editingId, setEditingId] = useState(null);
  const [newBalance, setNewBalance] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    onPageChange(newPage + 1); // API uses 1-based pagination
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    onRowsPerPageChange(newRowsPerPage);
  };

  const handleEdit = (id, currentBalance) => {
    setEditingId(id);
    setNewBalance(currentBalance);
  };

  const handleSave = (id) => {
    onUpdateBalance(id, parseFloat(newBalance));
    setEditingId(null);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading data</div>;
  }

  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>#</StyledTableCell>
              <StyledTableCell>Tenant Name</StyledTableCell>
              <StyledTableCell>Unit Name</StyledTableCell>
              <StyledTableCell>Property Name</StyledTableCell>
              <StyledTableCell>Landlord Business</StyledTableCell>
              <StyledTableCell>Total Amount Paid</StyledTableCell>
              <StyledTableCell>Period Rent</StyledTableCell>
              <StyledTableCell>Outstanding Balance</StyledTableCell>
              <StyledTableCell>Date Added</StyledTableCell>
              <StyledTableCell>Actions</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data && data.length > 0 ? (
              data.map((schedule, index) => (
                <StyledTableRow key={schedule.id}>
                  <StyledTableCell>{page * rowsPerPage + index + 1}</StyledTableCell>
                  <StyledTableCell>{schedule.tenant_name}</StyledTableCell>
                  <StyledTableCell>{schedule.unit_name}</StyledTableCell>
                  <StyledTableCell>{schedule.rental_name}</StyledTableCell>
                  <StyledTableCell>{schedule.landlord_business_name}</StyledTableCell>
                  <StyledTableCell>{schedule.total_amout_paid}</StyledTableCell>
                  <StyledTableCell>{schedule.period_rent}</StyledTableCell>
                  <StyledTableCell>
                    {editingId === schedule.id ? (
                      <TextField
                        type="number"
                        value={newBalance}
                        onChange={(e) => setNewBalance(e.target.value)}
                        size="small"
                      />
                    ) : (
                      schedule.outstanding_balance
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    {new Date(schedule.date_added).toLocaleDateString()}
                  </StyledTableCell>
                  <StyledTableCell>
                    {editingId === schedule.id ? (
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleSave(schedule.id)}
                      >
                        Save
                      </Button>
                    ) : (
                      <IconButton
                        onClick={() => handleEdit(schedule.id, schedule.outstanding_balance)}
                      >
                        <EditIcon />
                      </IconButton>
                    )}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={10} align="center">
                  No data available
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                colSpan={10}
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default CompletedSchedulesTable; 